<template>
  <div>
    <Breadcrumbs main="Contact Center Portal" title="Report Detail" />
    <div class="container-fluid">
      <div class="card p-4">
        <dataTableVue
          ref="refDataTable"
          :isSearch="false"
          :isExport="true"
          :isFilter="true"
          v-bind:data="{
            module: 'ccp',
            columns: columns,
            rows: rows,
            exportDetail: exportDetail,
            filter_custom: 'filterReportDynamicVue',
          }"
          @load="loadItems"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { requestService } from '../../../_services';

  export default {
    data() {
      return {
        rows: [],
        columns: [
          {
            label: 'Tracking ID',
            field: 'tracking_id',
            hidden: false,
          },
          {
            label: 'Sender',
            field: 'sender',
            hidden: false,
          },
          {
            label: 'Subject',
            field: 'subject',
            hidden: false,
          },
          {
            label: 'Type',
            field: 'mail_type',
            hidden: false,
          },
          {
            label: 'Receive Date',
            field: 'received_date_time',
            hidden: false,
          },
          {
            label: 'Distribute Date',
            field: 'distribute_date_time',
            hidden: false,
          },
          {
            label: 'Name',
            field: 'user_name',
            hidden: false,
          },
        ],
        exportDetail: {
          fileName: 'export_detail_report',
          exportUrl: '',
        },
      };
    },
    watch: {
      show(newValue, oldValue) {
        if (oldValue) {
          this.form.map((item, i) => {
            this.form[i].value = '';
          });
        }
      },
    },
    async created() {
      await this.loadItems();
    },

    methods: {
      async loadItems(event) {
        var str = '';
        if (event != undefined) {
          for (var key in event.params) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.params[key]);
          }
          this.columns.forEach((element) => {
            if (event.sortField == element.field) {
              if (
                event.sortField == 'created_at' ||
                event.sortField == 'updated_at'
              ) {
                str += '&' + 'sortField=' + event.sortField;
              } else {
                str += '&' + 'sortField=' + element.field;
              }
            }
          });
          if (event.filter != undefined) {
            for (var key in event.filter) {
              if (str != '') {
                str += '&';
              }
              str += key + '=' + encodeURIComponent(event.filter[key]);
            }
          }
        } else {
          str = 'sortType=desc&page=1&limit=50&sortField=received_date_time';
        }

        let url = '/api/mail/report/detail/filter?' + str;
        this.exportDetail.exportUrl = '/api/mail/report/detail/export?' + str;
        return requestService
          .GetFetch('ccp', url)
          .then((response) => {
            if (response.status == 200) {
              response.text().then((text) => {
                let self = this;
                self.rows = [];
                const data = text && JSON.parse(text);

                if (data.data.data != null) {
                  self.json_data = data.data.data;
                  self.rows = data.data.data;
                  self.$refs.refDataTable.setTotalRecords(data.data.total);
                  self.$refs.refDataTable.setPages(data.data.current_page);
                } else {
                  self.$refs.refDataTable.setTotalRecords(0);
                  self.$refs.refDataTable.setPages(1);
                }
              });
            }
          })
          .catch((error) => {
            this.$notify({ text: error, type: 'danger' });
          });
      },
    },
  };
</script>

<style></style>
